module.exports = "/static/assets/af2202211ca1873edb949012dab6f9d1.svg";